






































import {
  Vue,
  Component,
  Prop,
  Emit,
  Ref,
  Watch,
  Inject
} from "vue-property-decorator";
import {
  DeviceController,
  VideoInputDevice,
  ConsoleLogger
} from "amazon-chime-sdk-js";

import { getVideoInputDevice } from "@/utils/device";

@Component({
  data() {
    return {
      display: false
    };
  }
})
export default class VideoPreview extends Vue {
  @Prop({ default: false }) initialState!: boolean;
  @Prop({ required: true }) deviceController!: DeviceController;
  @Prop({ required: true }) device!: MediaDeviceInfo;
  @Prop({ default: false }) isBlurVideo!: boolean;
  @Ref() video!: HTMLVideoElement;
  @Inject() readonly chimeLogger!: ConsoleLogger;
  private display = false;

  togglePreview(on: boolean) {
    this.display = on;
    this.triggerPreview();
    this.displaying();
  }

  get hasDevice() {
    return Boolean(this.device);
  }

  @Watch("device")
  onHasDeviceChange() {
    this.triggerPreview();
  }

  @Watch("isBlurVideo")
  onIsBlurVideoChange() {
    this.triggerPreview();
  }

  async triggerPreview() {
    if (this.hasDevice) {
      if (this.display) {
        // Device controller might not have device
        const videoInputDevice: VideoInputDevice | null = await getVideoInputDevice(
          this.device,
          this.isBlurVideo,
          this.chimeLogger
        );
        await this.deviceController.chooseVideoInputDevice(videoInputDevice);
        this.deviceController.startVideoPreviewForVideoInput(this.video);
      } else {
        this.deviceController.stopVideoPreviewForVideoInput(this.video);
      }
    }
  }

  created() {
    this.display = this.initialState;
  }

  @Emit()
  displaying() {
    return this.display;
  }
}
